module.exports = __webpack_public_path__ + "img/hzmbg-vehicle-company-sample.3f8ae0df.png";